//Todo: We should remove all the closest to... comments and just use the actual values from the modus-wc tokens.
export const GRAY_0 = '#eaeaef'; // closest to --modus-wc-color-gray-02 (#e9eaf0)
export const GRAY_1 = '#e2e2e7'; // closest to --modus-wc-color-gray-0 (#e0e1e9)
export const GRAY_LIGHT = '#f3f3f7'; // closest to --modus-wc-color-gray-light (#f1f1f6)
export const TRIMBLE_GRAY_LIGHT = '#595868'; // closest to --modus-wc-color-gray-light-trimble (#f5f5f8)
export const TRIMBLE_GRAY = '#363545'; // closest to --modus-wc-color-gray-9 (#353a40); --modus-wc-color-trimble-gray is #252a2e
export const TRIMBLE_BLUE_MID = '#005f9e'; // closest to --modus-wc-color-trimble-blue (#0063a3)
export const TRIMBLE_GRAY_CONTENT = '#6a6976'; // closest to --modus-wc-color-gray-6 (#6a6e79)
/** Stage text-link blue (eyedropped from legacy right-panel / activity anchors). */
export const ANCHOR_LINK_COLOR = '#007ad9';
export const ANCHOR_LINK_HOVER_COLOR = '#116fbf';
export const GRAY_8 = '#6a6976'; // closest to --modus-wc-color-gray-6 (#6a6e79)
export const GRAY_9 = '#464548'; // closest to --modus-wc-color-gray-8 (#464f5a); used for dark text (switcher name)
export const TRIMBLE_BLUE_LIGHT = '#e5f0f8'; // no direct modus-wc equivalent; active-item highlight background
export const GRAY_6 = '#8c8b96'; // closest to --modus-wc-color-gray-4 (#90939f)
export const GRAY_2 = '#d0d0d7'; // closest to --modus-wc-color-gray-1 (#cbcdd6)
export const GRAY_3 = '#bfbfc6'; // closest to --modus-wc-color-gray-2 (#b7b9c3)
export const GRAY_4 = '#aeaeb6'; // closest to --modus-wc-color-gray-3 (#a3a6b1)
export const WHITE = '#ffffff'; // exact match for --modus-wc-color-white
export const TEXT_MUTED = '#666666'; // no direct modus-wc equivalent
export const ROW_HOVER = '#f0f0f0'; // closest to --modus-wc-color-gray-light (#f1f1f6)
